// extracted by mini-css-extract-plugin
export default {"pageTabsWrapper":"src-components-PageTabs-index-module_pageTabsWrapper--O8uh2","rtlPageTabsWrapper":"src-components-PageTabs-index-module_rtlPageTabsWrapper--lgBkR"};